var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    ref: "menu",
    staticClass: "mt-0 pt-0",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        _vm.date = $event;
      },
      "update:return-value": function updateReturnValue($event) {
        _vm.date = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: '##.##.####',
            expression: "'##.##.####'"
          }],
          staticClass: "py-0",
          attrs: {
            "disabled": _vm.disabled,
            "outlined": "",
            "dense": "",
            "rounded": "",
            "readonly": "",
            "label": _vm.label,
            "placeholder": _vm.placeholder,
            "clearable": _vm.clearable,
            "hide-details": _vm.hideDetails,
            "height": 20,
            "error-messages": _vm.errorMessage
          },
          on: {
            "change": _vm.setDate,
            "click:clear": _vm.clear,
            "blur": function blur($event) {
              return _vm.$emit('blur');
            }
          },
          model: {
            value: _vm.dateFormatted,
            callback: function callback($$v) {
              _vm.dateFormatted = $$v;
            },
            expression: "dateFormatted"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function callback($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "locale": "ru-RU",
      "color": "green primary",
      "format": "DD.MM.YYYY",
      "first-day-of-week": "1",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function input($event) {
        return _vm.save(_vm.date);
      }
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }